<template lang="html">
  <div>
    <a id="add-to-shopping-list"/>

    <template v-for="list in recipe.ingredient_lists">
      <!-- eslint-disable-next-line vue/require-v-for-key -->
      <div class="list-header" v-if="list.name">
        {{ list.name }}
      </div>

      <!-- eslint-disable-next-line vue/require-v-for-key -->
      <div class="list">
        <ingredient-item
          v-for="(ingredient, index) in list.ingredient_items"
          :key="index"
          :ingredient-item="ingredient"
          :orginal-serving-count="recipe.serving_count"
          :current-serving-count="current"
          :selectable="selectable"
        />
      </div>

    </template>


    <!-- eslint-disable-next-line vue/no-confusing-v-for-v-if -->
    <template v-for="linked in recipe.linked_recipes" v-if="recipe.linked_recipes">
      <template v-if="linked.ingredient_lists && linked.ingredient_lists.length > 0">
        <!-- eslint-disable-next-line vue/require-v-for-key -->
        <p class="panel-heading is-small">
          {{ linked.name }}
        </p>
        <template v-for="list in linked.ingredient_lists">
          <!-- eslint-disable-next-line vue/require-v-for-key -->
          <div class="list-header" v-if="list.name">
            {{ list.name }}
          </div>

          <!-- eslint-disable-next-line vue/require-v-for-key -->
          <div class="list">
            <ingredient-item
              v-for="(ingredient, index) in list.ingredient_items"
              :key="index"
              :ingredient-item="ingredient"
              :orginal-serving-count="recipe.serving_count"
              :current-serving-count="current"
              :selectable="selectable"
            />
          </div>

        </template>
      </template>
    </template>

    <nav class="panel-block is-centered has-bottom-padding no-print" v-show="!$user.loading">
      <button class="button is-primary is-inverted" v-show="!selectable" @click="enableSelection">
        <b-icon icon="shopping-basket"/><span> {{ $t('add to shopping list') }}</span>
      </button>

      <div class="buttons" v-show="selectable">
        <div class="placeholder-block"/>
        <button
          class="button"
          :class="mode === 'save' ? 'is-loading is-white' : mode === 'success' ? 'is-successfull' : 'is-info is-outlined'"
          :disabled="mode === 'save'"
          @click="addToList"
        >
          {{ $t('save') }}
        </button>

        <button
          class="button is-black is-inverted"
          :disabled="mode === 'save' || mode === 'success'"
          @click="disableSelection"
        >
          {{ $t('cancel') }}
        </button>
      </div>
    </nav>

    <slot name="footer"/>
  </div>
</template>

<script>
import Promise from 'bluebird'
import format from 'shared/lib/format'
import SHARED from './shared'
import IngredientItem from './Item.vue'

export default {
  components: {
    IngredientItem
  },

  data(){
    return SHARED
  },

  created(){
    this.$root.$on('openShoppingSelection', this.enableSelection)
    this.$root.$emit('serving_count_change', this.current)
  },

  watch: {
    current(value){
      this.$root.$emit('serving_count_change', this.current)
    }
  },

  computed: {
    ingredient_items(){
      const items = []

      items.concat(this.recipe, this.recipe.linked_recipes)
      .forEach(recipe => {
        recipe.ingredient_lists.forEach(list => {
          list.ingredient_items.forEach(ingredient => {
            items.push(ingredient)
          })
        })
      })

      return items
    }
  },

  methods: {
    preselect(){
      if(this.preselected) return
      // preselect all items
      this.ingredient_items.forEach(ingredient => {
        this.$set(ingredient, 'selected', !ingredient.hide_on_shopping)
        this.$set(ingredient, 'saved', false)
      })

      this.preselected = true
    },

    enableSelection(){
      if(!this.$user.authenticated) return this.$user.showLoginDialog()
      this.preselect()
      clearTimeout(this.$timeout)
      this.selectable = true
    },

    disableSelection(){
      clearTimeout(this.$timeout)
      this.selectable = false
      this.mode = 'display'
    },

    addToList(){
      this.mode = 'save'

      const items = this.ingredient_items.filter((item) => item.selected)

      Promise.map(items, item => {
        let multiplicator = 1
        if(this.current > 0 && this.recipe.serving_count) multiplicator = this.current / this.recipe.serving_count

        let amount = format.ingredientAmount(item, multiplicator)
        if(typeof amount === 'string') amount = null

        // save a single item
        return this.$api.addShoppingItem({
          annotation: item.name || item.ingredient.name,
          ingredient_list_item_id: item.id,
          multiplicator
        })
        .then(result => {
          if(!result.id) throw new Error('save failed!')

          // and unselect after success
          item.selected = false
          item.saved = true
        })
      }, {concurrency: 1})
      .then(result => {
        this.mode = 'success'
        this.$timeout = setTimeout(() => {
          this.selectable = false
          this.mode = 'display'
        }, 1000)
      })
      .catch(e => {
        console.error(e)
        this.$toast.open({
          message: 'Beim Speichern ist ein Fehler aufgetreten!',
          type: 'is-danger'
        })
        this.mode = 'display'
      })
    }
  }
}
</script>

<i18n>
{
  "de_at": {
    "save": "Speichern",
    "cancel": "Abbrechen",
    "add to shopping list": "Zum Einkaufszettel"
  },
  "cs": {
    "save": "Uložit",
    "cancel": "zrušení",
    "add to shopping list": "přidat do nákupního seznamu"
  },
  "hu": {
    "save": "mentés",
    "cancel": "megszünteti",
    "add to shopping list": "hozzáadás a bevásárlási listához"
  },
  "fr": {
    "save": "enregistrer",
    "cancel": "Annuler",
    "add to shopping list": "ajouter à la liste d'achats"
  }
}
</i18n>

<style lang="scss">
</style>



// WEBPACK FOOTER //
// src/components/ingredients/List.vue